import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '../lib/api'
import type {
  MarkirovkaDocumentFilters,
  MarkirovkaIncomingDocumentsList,
  MarkirovkaDocumentMarksResponse,
} from '../types/markirovka-stock.types'

const DOCS_QUERY_KEY = 'markirovka-documents'

export const useMarkirovkaDocuments = (filters: MarkirovkaDocumentFilters = {}) => {
  return useQuery({
    queryKey: [DOCS_QUERY_KEY, filters],
    queryFn: async (): Promise<MarkirovkaIncomingDocumentsList> => {
      return apiClient.getMarkirovkaDocuments(filters)
    },
    staleTime: 30 * 1000,
    retry: 1,
  })
}

export const useMarkirovkaDocumentMarks = (id: string | null) => {
  return useQuery({
    queryKey: [DOCS_QUERY_KEY, 'marks', id],
    queryFn: async (): Promise<MarkirovkaDocumentMarksResponse> => {
      return apiClient.getMarkirovkaDocumentMarks(id as string)
    },
    enabled: !!id,
    staleTime: 30 * 1000,
    retry: 1,
  })
}

export const useToggleDocumentExcluded = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (vars: { id: string; isExcluded: boolean }) =>
      apiClient.toggleMarkirovkaDocumentExcluded(vars.id, vars.isExcluded),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [DOCS_QUERY_KEY] })
    },
  })
}
